// Virtualized table dimensions in px
export const DEFAULT_TABLE_HEADER_HEIGHT = 48;
export const DEFAULT_TABLE_ROW_HEIGHT = 40;
export const DROP_SHADOW_HEIGHT = 5;

// Virtualized table column width parameters in px
export const MIN_WIDTH_ACTIONS = 80;
export const MIN_WIDTH_CHECKBOX = 150;
export const MIN_WIDTH_DEFAULT = 250;
export const MIN_WIDTH_EMAIL = 300;
export const MIN_WIDTH_ENTITIES = 250;
export const MIN_WIDTH_NAME = 250;
export const MIN_WIDTH_RESOURCES = 300;
export const MIN_WIDTH_ROLES = 250;
export const MIN_WIDTH_SERVICES = 250;

export const SHOW_MODAL = "shared/SHOW_MODAL";
export const HIDE_MODAL = "shared/HIDE_MODAL";
